module.exports = __webpack_public_path__ + "static/media/ArrowDown.b6fa851d.svg";